import type { Database } from '@pharmaconnect/types'
import { createClient, type SupabaseClient } from '@supabase/supabase-js'

export type TypedSupabaseClient = SupabaseClient<Database>

export interface SupabaseClientOptions {
  url: string
  anonKey: string
  /** Optionnel — pour Edge Functions / serveur uniquement (jamais frontend). */
  serviceRoleKey?: string
  /** AsyncStorage pour React Native, undefined côté Node/Edge, localStorage par défaut côté web. */
  storage?: unknown
  /** Si `true`, persiste la session (web). Mettre à `false` pour Edge Functions. */
  persistSession?: boolean
}

/** Client Supabase typé — destiné au frontend (anon key + RLS). */
export const createSupabaseClient = (options: SupabaseClientOptions): TypedSupabaseClient => {
  const { url, anonKey, storage, persistSession = true } = options
  return createClient<Database>(url, anonKey, {
    auth: {
      persistSession,
      autoRefreshToken: persistSession,
      detectSessionInUrl: persistSession,
      ...(storage ? { storage: storage as never } : {}),
    },
  })
}

/**
 * Client Supabase avec service-role — réservé aux Edge Functions.
 * Bypass RLS : à utiliser uniquement après vérifications d'autorisation explicites.
 */
export const createSupabaseAdminClient = (options: SupabaseClientOptions): TypedSupabaseClient => {
  if (!options.serviceRoleKey) {
    throw new Error('serviceRoleKey requis pour le client admin')
  }
  return createClient<Database>(options.url, options.serviceRoleKey, {
    auth: { persistSession: false, autoRefreshToken: false, detectSessionInUrl: false },
  })
}
